export const ReasonsForAbsence = Object.freeze([
  {
    id: 'Not Provided',
    translationKey: 'booking.reasonForAbsence.notProvided',
  },
  {
    id: 'Sick Leave Cover',
    translationKey: 'booking.reasonForAbsence.sickLeaveCover',
  },
  {
    id: 'Professional Development',
    translationKey: 'booking.reasonForAbsence.professionalDevelopment',
  },
  {
    id: 'Annual Leave Cover',
    translationKey: 'booking.reasonForAbsence.annualLeaveCover',
  },
  {
    id: 'Break Cover',
    translationKey: 'booking.reasonForAbsence.breakCover',
  },
  {
    id: 'Vacant Position',
    translationKey: 'booking.reasonForAbsence.vacantPosition',
  },
  {
    id: 'Training Cover',
    translationKey: 'booking.reasonForAbsence.trainingCover',
  },
  {
    id: 'Government Funding',
    translationKey: 'booking.reasonForAbsence.governmentFunding',
  },
  {
    id: 'Rostered Day Off',
    translationKey: 'booking.reasonForAbsence.rosteredDayOff',
  },
  {
    id: "Carer's Leave",
    translationKey: 'booking.reasonForAbsence.carersLeave',
  },
  {
    id: 'Long Service Leave',
    translationKey: 'booking.reasonForAbsence.longServiceLeave',
  },
  {
    id: 'F&P Testing',
    translationKey: 'booking.reasonForAbsence.fpTesting',
  },
  {
    id: 'Professional Practice Day',
    translationKey: 'booking.reasonForAbsence.professionalPracticeDay',
  },
  {
    id: 'Leave Without Pay',
    translationKey: 'booking.reasonForAbsence.leaveWithoutPay',
  },
  {
    id: 'Other',
    translationKey: 'booking.reasonForAbsence.other',
  },
])
